import type { FC } from 'react';
import { Button } from '../Button';
import btnIllustrationBlue from './assets/btn-illustration-blue.svg';
import btnIllustrationPurple from './assets/btn-illustration-purple.svg';
import * as Styled from './styled';
import type { BannerProps } from './types';

export * from './types';

export const Banner: FC<BannerProps> = (props) => {
  const {
    title,
    text,
    btnText,
    backgroundImage,
    iconLeft,
    iconRight,
    image,
    theme = 'blue',
    onClick,
    breakSpaces = false,
    noArrow = false,
    center = false,
  } = props;

  // prettier-ignore
  const btnIllustration = {
    'blue': btnIllustrationBlue,
    'purple': btnIllustrationPurple,
  };

  return (
    <Styled.Container
      onClick={onClick}
      bgImage={backgroundImage}
      clickable={!!onClick}
      center={center}
    >
      <Styled.ContentContainer>
        <Styled.Title bannerTheme={theme}>{title}</Styled.Title>
        {text && <Styled.Text>{text}</Styled.Text>}

        {btnText && onClick && (
          <Styled.ButtonContainer center={center}>
            <Button
              color={theme}
              shrink
              {...(iconLeft && { iconLeft })}
              {...(iconRight && { iconRight })}
              {...(breakSpaces && { breakSpaces })}
            >
              {btnText}
            </Button>
            {!noArrow && <img src={btnIllustration[theme]} alt="" width={100} />}
          </Styled.ButtonContainer>
        )}
      </Styled.ContentContainer>

      {image ? (
        <Styled.ImageContainer>
          <img src={image} alt="" />
        </Styled.ImageContainer>
      ) : null}
    </Styled.Container>
  );
};
